import React, { Suspense, lazy } from 'react';

import ApiErrorBoundary from '@components/Common/Error/ApiErrorBoundary';
import StockholderListSkeleton from '@components/Group/Portfolio/Skeleton/StockholderListSkeleton';

const StockholderList = lazy(
  () => import('@components/Group/Portfolio/StockholderList')
);

/** 조합 관리 > 상세 > 포트폴리오 상세 > 주요 주주 */
const Stockholder = () => {
  return (
    <>
      <ApiErrorBoundary>
        <Suspense fallback={<StockholderListSkeleton />}>
          <StockholderList />
        </Suspense>
      </ApiErrorBoundary>
    </>
  );
};

export default Stockholder;
